'use client';
import cn from 'classnames';

import style from './ButtonBigCall.module.scss';

function ButtonBigCall({ className, handleFuction, text, testId }) {
  return (
    <button className={cn(className, style.buttonBigCall)} onClick={handleFuction} data-testid={testId}>
      <div className={style.buttonBigCallText}>{text}</div>
    </button>
  );
}

export default ButtonBigCall;
